module.exports = App.FileDroppableMixin = Em.Mixin.create
  isDraggedOver: false

  __onDragEnter: (e) ->
    e.preventDefault()
    e.stopPropagation()
    @set 'isDraggedOver', true

  __onDragOver: (e) ->
    e.preventDefault()
    e.stopPropagation()
    @set 'isDraggedOver', true

  __onDragLeave: (e) ->
    e.preventDefault()
    e.stopPropagation()
    @set 'isDraggedOver', false

  __onDrop: (e) ->
    e.preventDefault()
    e.stopPropagation()

    @set 'isDraggedOver', false
    return unless e.originalEvent.dataTransfer?.files?.length

    files = e.originalEvent.dataTransfer.files
    @send 'filesDropped', files

  installDragDropHandlers: (->
    @$().on('drop',      @__onDrop.bind(@))
    @$().on('dragover',  @__onDragOver.bind(@))
    @$().on('dragenter', @__onDragEnter.bind(@))
    @$().on('dragleave', @__onDragLeave.bind(@))
  ).on('didInsertElement')

  willDestroyElement: (->
    @$().off('drop dragover dragenter dragleave')
  ).on('willDestroyElement')

